// libraries
import React from "react";

// components
import { IntegrationsSections } from "../web-settings";
import { ZoomPersonalSettings } from "@components/zoom-personal-settings";

// assets
import { ZoomLogo } from "@clockwise/web-commons/src/components/svgs/ZoomLogo";

// material-ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Zoom Settings
// ~-~-~-~-~-~-~-
interface ZoomIntegrationProps {
  org: any;
  refetch: () => void;
}

const useStyles = makeStyles({
  h3: {
    display: "flex",
    alignItems: "center",
    marginBottom: 22,
  },
  zoomLogo: {
    marginRight: 7,
  },
});

export const ZoomIntegration = (props: ZoomIntegrationProps) => {
  const classes = useStyles();
  return (
    <div cw-id={`web-settings-${IntegrationsSections.Zoom}`}>
      <Typography variant="h3" className={classes.h3}>
        <ZoomLogo className={classes.zoomLogo} />
        Zoom
      </Typography>
      <Typography variant="subtitle1">
        Connect your Zoom account to automatically add Zoom video conferencing to meetings you
        schedule with Clockwise.{" "}
        <a href={"https://getclockwise.com"} target="_blank">
          Learn more
        </a>
        .
      </Typography>
      <ZoomPersonalSettings org={props.org} refetch={props.refetch} hideDescription />
    </div>
  );
};
